import React from 'react';
import get from 'lodash/get';

import classNames from 'classnames';
import propTypes from 'prop-types';
import accountPropTypes from 'apps/account/propTypes';
import { TranslatedMessage } from 'common/components/Intl';
import PriceSpan from 'common/components/formatters/PriceSpan';
import NicotineOptions from './NicotineOptions';
import PodCountOptions from './PodCountOptions';
import QuickShopProductInformation from './QuickShopProductInformation';
import QuickShopDualCTA from '../containers/QuickShopDualCTA';
import VariantPendingQuantityInput from '../containers/VariantPendingQuantityInput';
import AddToCartButton from '../containers/AddToCartButton';

export default class QuickShopContent extends React.Component {
  static propTypes = {
    selectedVariant: accountPropTypes.ProductVariant,
    closeQuickShopModal: propTypes.func,
    changeSelectedVariant: propTypes.func.isRequired,
    currentOrder: accountPropTypes.OrderWithLineItems.isRequired,
    productDisplayPage: propTypes.bool.isRequired,
    reviewsElementId: propTypes.string,
    showDescription: propTypes.bool,
    showDetailsLink: propTypes.bool,
    showExciseTaxDisclaimer: propTypes.bool.isRequired,
  };

  defaultToAutoshipEnabled = () => {
    const defaultToAutoship = get(
      this.props,
      'splitTreatments.default-to-autoship'
    );

    return defaultToAutoship === 'on';
  };

  renderVariantActionsForm = () => {
    const {
      selectedVariant,
      closeQuickShopModal,
      currentOrder,
      productDisplayPage,
    } = this.props;

    return (
      <div className="variant-actions-form">
        <div className="variant-actions-form__quantity">
          <label>
            <TranslatedMessage id="quantity" />
          </label>
          <VariantPendingQuantityInput
            order={currentOrder}
            variant={selectedVariant}
            defaultQuantity={1}
            className={'variant-actions-form__quantity__input'}
            offeringId={selectedVariant.offeringId}
          />
        </div>

        <div
          className={classNames(
            'variant-actions-form__price',
            'heading--title--small',
            {
              'variant-actions-form__price--quick-shop-modal': !productDisplayPage,
            }
          )}
        >
          <PriceSpan amount={selectedVariant.price} />
        </div>

        <AddToCartButton
          className={classNames('variant-actions-form__button', {
            'variant-actions-form__button--quick-shop-modal': !productDisplayPage,
          })}
          sku={selectedVariant.sku}
          isSubscriberExclusive={selectedVariant.subscriberExclusive}
          onClick={closeQuickShopModal}
          isSoldOut={selectedVariant.isSoldOut}
          offeringId={selectedVariant.offeringId}
        />
      </div>
    );
  };

  render() {
    const {
      closeQuickShopModal,
      currentOrder,
      selectedVariant,
      productDisplayPage,
      showDetailsLink,
      showDescription,
      showExciseTaxDisclaimer,
      reviewsElementId,
    } = this.props;

    return (
      <div className="quickShop__content">
        <QuickShopProductInformation
          productDisplayPage={productDisplayPage}
          reviewsElementId={reviewsElementId}
          showDescription={!!showDescription}
          showDetailsLink={!!showDetailsLink}
          variant={selectedVariant}
        />

        <div className="quick-shop__options">
          <NicotineOptions {...this.props} />
          <PodCountOptions {...this.props} />
        </div>

        {!this.defaultToAutoshipEnabled() && this.renderVariantActionsForm()}

        {this.defaultToAutoshipEnabled() && (
          <QuickShopDualCTA
            currentOrder={currentOrder}
            selectedVariant={selectedVariant}
            closeQuickShopModal={closeQuickShopModal}
            productDisplayPage={productDisplayPage}
          />
        )}

        {showExciseTaxDisclaimer && (
          <p className="input__helper-text">
            <TranslatedMessage id={'shared.excise_tax_disclaimer'} />
          </p>
        )}
      </div>
    );
  }
}

QuickShopContent.defaultProps = {
  productDisplayPage: false,
};
